// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4fd6f40e","667":"136bebd9"}[chunkId] + ".chunk.js";
};